import React from 'react';
import FilterComponent from '../common/FilterComponent';
import { ordinalDate } from '../utils/Utils';

const StoryFilter = ({ list, handleChange, initialFilters }) => {
  const handleObjChange = (filterObject) => {
    let temp = [];
    filterObject?.types?.forEach((item) => {
      list?.forEach((story) => {
        story?.type?.forEach((ty) => {
          let tempType = item;
          if (item === 'BLOG') {
            tempType = 'ROCKED_ARTICLE';
          }
          if (item === 'NEWS ARTICLE') {
            tempType = 'ARTICLE';
          }
          if (ty === tempType) {
            const check = temp.some((e) => e.publishDate === story.publishDate);
            if (!check) {
              temp.push(story);
            }
          }
        });
      });
    });
    temp?.sort((a, b) => new Date(b.publishDate) - new Date(a.publishDate));
    if (filterObject?.searchTerm !== '') {
      temp = filterObject?.searchTerm
        ? temp.filter((item) =>
            ordinalDate(item.publishDate).toLowerCase().includes(filterObject?.searchTerm.toLowerCase()),
          )
        : temp;
    }
    handleChange([...temp]);
  };
  return <FilterComponent handleObjChange={handleObjChange} filter={initialFilters} type="Stories" />;
};

export default StoryFilter;
